import { render } from "./HeroLoading.vue?vue&type=template&id=dcf15a0e&scoped=true"
import script from "./HeroLoading.vue?vue&type=script&lang=js"
export * from "./HeroLoading.vue?vue&type=script&lang=js"

import "./HeroLoading.vue?vue&type=style&index=0&id=dcf15a0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcf15a0e"]])

export default __exports__